export const ourResultFromGoals = (goals: any[]) => {
    const ourGoals = ourGoalsFromGoals(goals);
    const opponentGoals = opponentGoalsFromGoals(goals);
    if (ourGoals > opponentGoals) {
        return 'Win';
    } if (opponentGoals > ourGoals) {
        return 'Loss';
    } if (opponentGoals === ourGoals) {
        return 'Tied';
    }
    return '-';
};

export const ourShortenedResultFromGoals = (goals: any[]) => {
    const ourGoals = ourGoalsFromGoals(goals);
    const opponentGoals = opponentGoalsFromGoals(goals);
    if (ourGoals > opponentGoals) {
        return 'W';
    } if (opponentGoals > ourGoals) {
        return 'L';
    } if (opponentGoals === ourGoals) {
        return 'T';
    }
    return '-';
};

export const ourGoalsFromGoals = (goals: any[]) => {
    let total = 0;
    goals.forEach((goal: any) => {
        total += goal.team === 'our' ? 1 : 0;
    });
    return total;
};

export const ourPowerPlayGoalsFromGoals = (goals: any[]) => {
    let total = 0;
    goals.forEach((goal: any) => {
        total += goal.team === 'our' && goal.powerPlayGoal ? 1 : 0;
    });
    return total;
};

export const ourShortHandedGoalsFromGoals = (goals: any[]) => {
    let total = 0;
    goals.forEach((goal: any) => {
        total += goal.team === 'our' && goal.shortHandedGoal ? 1 : 0;
    });
    return total;
};

export const ourGameWinningGoalsFromGoals = (goals: any[]) => {
    let total = 0;
    goals.forEach((goal: any) => {
        total += goal.team === 'our' && goal.gameWinningGoal ? 1 : 0;
    });
    return total;
};

export const ourEmptyNetGoalsFromGoals = (goals: any[]) => {
    let total = 0;
    goals.forEach((goal: any) => {
        total += goal.team === 'our' && goal.emptyNetGoal ? 1 : 0;
    });
    return total;
};

export const ourShotsFromHighlights = (highlights: any[]) => {
    let total = 0;
    highlights.forEach((highlight: any) => {
        total += highlight.team === 'our' && highlight.type === 'shots' ? highlight.number : 0;
    });
    return total;
};

export const ourSavesFromHighlights = (highlights: any[]) => {
    let total = 0;
    highlights.forEach((highlight: any) => {
        total += highlight.team === 'our' && highlight.type === 'saves' ? highlight.number : 0;
    });
    return total;
};

export const ourBlocksFromHighlights = (highlights: any[]) => {
    let total = 0;
    highlights.forEach((highlight: any) => {
        total += highlight.team === 'our' && highlight.type === 'blocks' ? highlight.number : 0;
    });
    return total;
};

export const ourPenaltiesFromPenalties = (penalties: any[]) => {
    let total = 0;
    penalties.forEach((penalty: any) => {
        total += penalty.team === 'our' ? 1 : 0;
    });
    return total;
};

export const ourPenaltyMinutesFromPenalties = (penalties: any[]) => {
    let total = 0;
    penalties.forEach((penalty: any) => {
        total += penalty.team === 'our' ? penalty.penaltyTimeInSeconds : 0;
    });
    return total;
};

export const ourPowerplaysFromPowerplays = (powerplays: any[]) => {
    let total = 0;
    powerplays.forEach((powerplay: any) => {
        total += powerplay.team === 'our' ? 1 : 0;
    });
    return total;
};

// ---------------------------------------------------------------------------------------------------------
// Get opponent stats
// ---------------------------------------------------------------------------------------------------------

export const opponentResultFromGoals = (goals: any[]) => {
    const ourGoals = ourGoalsFromGoals(goals);
    const opponentGoals = opponentGoalsFromGoals(goals);
    if (ourGoals < opponentGoals) {
        return 'Win';
    } if (opponentGoals < ourGoals) {
        return 'Loss';
    } if (opponentGoals === ourGoals) {
        return 'Tied';
    }
    return '-';
};

export const opponentShortenedResultFromGoals = (goals: any[]) => {
    const ourGoals = ourGoalsFromGoals(goals);
    const opponentGoals = opponentGoalsFromGoals(goals);
    if (ourGoals < opponentGoals) {
        return 'W';
    } if (opponentGoals < ourGoals) {
        return 'L';
    } if (opponentGoals === ourGoals) {
        return 'T';
    }
    return '-';
};

export const opponentGoalsFromGoals = (goals: any[]) => {
    let total = 0;
    goals.forEach((goal: any) => {
        total += goal.team === 'opponent' ? 1 : 0;
    });
    return total;
};

export const opponentPowerPlayGoalsFromGoals = (goals: any[]) => {
    let total = 0;
    goals.forEach((goal: any) => {
        total += goal.team === 'opponent' && goal.powerPlayGoal ? 1 : 0;
    });
    return total;
};

export const opponentShortHandedGoalsFromGoals = (goals: any[]) => {
    let total = 0;
    goals.forEach((goal: any) => {
        total += goal.team === 'opponent' && goal.shortHandedGoal ? 1 : 0;
    });
    return total;
};

export const opponentGameWinningGoalsFromGoals = (goals: any[]) => {
    let total = 0;
    goals.forEach((goal: any) => {
        total += goal.team === 'opponent' && goal.gameWinningGoal ? 1 : 0;
    });
    return total;
};

export const opponentEmptyNetGoalsFromGoals = (goals: any[]) => {
    let total = 0;
    goals.forEach((goal: any) => {
        total += goal.team === 'opponent' && goal.emptyNetGoal ? 1 : 0;
    });
    return total;
};

export const opponentShotsFromHighlights = (highlights: any[]) => {
    let total = 0;
    highlights.forEach((highlight: any) => {
        total += highlight.team === 'opponent' && highlight.type === 'shots' ? highlight.number : 0;
    });
    return total;
};

export const opponentSavesFromHighlights = (highlights: any[]) => {
    let total = 0;
    highlights.forEach((highlight: any) => {
        total += highlight.team === 'opponent' && highlight.type === 'saves' ? highlight.number : 0;
    });
    return total;
};

export const opponentBlocksFromHighlights = (highlights: any[]) => {
    let total = 0;
    highlights.forEach((highlight: any) => {
        total += highlight.team === 'opponent' && highlight.type === 'blocks' ? highlight.number : 0;
    });
    return total;
};

export const opponentPenaltiesFromPenalties = (penalties: any[]) => {
    let total = 0;
    penalties.forEach((penalty: any) => {
        total += penalty.team === 'opponent' ? 1 : 0;
    });
    return total;
};

export const opponentPenaltyMinutesFromPenalties = (penalties: any[]) => {
    let total = 0;
    penalties.forEach((penalty: any) => {
        total += penalty.team === 'opponent' ? penalty.penaltyTimeInSeconds : 0;
    });
    return total;
};

export const opponentPowerplaysFromPowerplays = (powerplays: any[]) => {
    let total = 0;
    powerplays.forEach((powerplay: any) => {
        total += powerplay.team === 'opponent' ? 1 : 0;
    });
    return total;
};
